import { createContext } from "react";

const CatTipoPagoContext = createContext();

export default CatTipoPagoContext;
